module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dropdown', {
    attrs: {
      "split-button": "",
      "type": "default"
    },
    on: {
      "click": _vm.onClick,
      "command": _vm.onCommand
    }
  }, [_vm._v("\n    Edit form\n    "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "list"
    }
  }, [_vm._v("View submissions")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "settings"
    }
  }, [_vm._v("Settings...")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "duplicate"
    }
  }, [_vm._v("Duplicate form...")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "delete",
      "divided": ""
    }
  }, [_vm._v("Delete form")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bef9579"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/Forms/Actions.vue
// module id = 391
// module chunks = 4